import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

export default function Audit() {
  const { data: logs } = useQuery({ queryKey: ["audit"], queryFn: async () => (await api.get("/audit")).data });

  return (
    <div className="space-y-5">
      <h1 className="text-2xl sm:text-3xl font-head font-extrabold text-slate-900">Audit Log</h1>
      <div className="bg-white rounded-2xl border border-slate-200 divide-y divide-slate-100">
        {(logs || []).map((l) => (
          <div key={l.id} data-testid={`audit-row-${l.id}`} className="px-4 py-3 flex items-start gap-3">
            <div className="h-2 w-2 rounded-full bg-blue-500 mt-1.5 shrink-0" />
            <div className="min-w-0 flex-1">
              <div className="flex items-center justify-between gap-2">
                <span className="font-medium text-slate-900 text-sm">{l.action}</span>
                <span className="text-xs text-slate-400 shrink-0">{new Date(l.timestamp).toLocaleString()}</span>
              </div>
              <div className="text-xs text-slate-500">by {l.user_name || l.user_email} · {l.target}</div>
              {l.reason && <div className="text-xs text-orange-600 mt-0.5">Reason: {l.reason}</div>}
            </div>
          </div>
        ))}
        {(logs || []).length === 0 && <div className="px-4 py-6 text-sm text-slate-400">No audit entries yet.</div>}
      </div>
    </div>
  );
}
